<div class="container-fluid">
    <div class="d-flex justify-content-center align-items-center vh-100">
      <div class="card" style="width: 30rem;">
        <div class="card-body p-12">
          <h3 class="fw-normal text-start">Forgot Password?</h3>
          <div [ngClass]="{'alert': true, 'alert-success': alert.Success, 'alert-danger': !alert.Success }"
            *ngIf="alert.Visible" class="alert alert-danger mt-3">
            <span [ngClass]="{'fa-check-circle': alert.Success, 'fa-exclamation-circle': !alert.Success}"
              aria-hidden="true" class="fas fa-exclamation-circle me-2"></span>
            <span [innerHTML]="alert.Message"></span>
          </div>
          <form (submit)="Submit()">
            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-3">
                  <div class="input-group input-group-lg ">
                    <div class="input-group-text input-group-text rounded-start">
                      <span>
                        <i class="fas fa-user fa-lg"></i>
                      </span>
                    </div>
                    <input type="text" class="form-control form-control-lg rounded-end ps-2 border-start-0"
                      style="height: 50px;" [(ngModel)]="Email" placeholder="Login / Email" aria-label="Username" name="email"
                      aria-describedby="basic-addon1">
                  </div>
                  <div *ngIf="alert.Success" class="input-group input-group-lg mt-8">
                    <div class="input-group-text rounded-start">
                      <span>
                        <i class="fas fa-key fa-lg"></i>
                      </span>
                    </div>
                    <input [type]="inputType" #passAutoFocus [(ngModel)]="Password" name="Password" id="inputPassword" style="height: 50px;"
                    class="form-control form-control-lg rounded-end ps-2 border-start-0 border-end-0" placeholder="Password" required #password="ngModel">
                    <span class="input-group-text border-start-0 rounded-end">
                      <i class="{{showHideClass}} fas" *ngIf="password" (click)="showPassword()"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-md-flex justify-content-between mt-6">
              <div class="order-md-last">
                <input type="submit" class="btn btn-lg btn-success rounded-1 fw-normal rounded-0" />
              </div>
              <div class="order-md-first">
                <a class="return" [routerLink]="['/']">Return to login page</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="d-flex justify-content-start mb-11 mx-11 footer-mobile">
        <div>
          <span>powered by :</span>
          <a target="_blank" href="http://www.dealpos.com"></a>
          <img class="ms-3 border-0" src="//res.cloudinary.com/pos/image/upload/POS/Images/Login/dealpos.png">
        </div>
      </div>
    </div>
  </div>